import { Store } from 'redux';
import { LoaderFunction, redirect } from 'react-router-dom';

import { Language } from '@ha/intl';

import {
  getIsAuthenticated,
  getIsUnderReview,
  getCurrentLanguage,
} from 'ha/modules/AuthLogic/selectors';
import { HttpStatus } from 'ha/constants/HttpStatus';
import { formatHrefURL } from 'ha/utils/formatHrefURL';
import { Config } from 'ha/config';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

export const myPagesGuard =
  (store: Store, config: Config): LoaderFunction =>
  ({ request }) => {
    if (!getIsAuthenticated(store.getState())) {
      const lang = getCurrentLanguage(store.getState());
      const url = new URL(request.url);
      url.searchParams.set('return_url', `${url.pathname}${url.search}`);
      url.pathname = formatHrefURL('/login', lang as Language);

      const { enableOAuthTokamak } = getFeatureFlags(store.getState());

      if (enableOAuthTokamak === 'on' && config.authEnabled) {
        //eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw redirect(
          `/oauth/signin${url.search}`,
          HttpStatus.FOUND_REDIRECTION,
        );
      }

      //eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect(
        `${url.pathname}${url.search}`,
        HttpStatus.FOUND_REDIRECTION,
      );
    }

    if (getIsUnderReview(store.getState())) {
      //eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect('/under-review', HttpStatus.FOUND_REDIRECTION);
    }

    return null;
  };
